//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Informatie',
  data: () => ({
    headerImg: require('~/assets/img/studentenlidmaatschap.jpg'),
  }),
};
